
import apiFetch from '@wordpress/api-fetch';
import { addFilter } from '@wordpress/hooks';
import { createHigherOrderComponent } from '@wordpress/compose';

window.PostGridPluginData = {
    freeUrl: "https://wordpress.org/plugins/post-grid/",
    proUrl: "https://pickplugins.com/post-grid/",
    websiteUrl: "https://pickplugins.com/",
    demoUrl: "http://getpostgrid.com/",
    wpReviewUrl: "https://wordpress.org/support/plugin/post-grid/reviews/#new-post",
    reviewUrl: "http://getpostgrid.com/submit-review",

    renewLicense: "https://pickplugins.com/renew-license/?licenseKey=",
    hasSubscribed: false,

    utm: {
        utm_source: "",
        utm_medium: "",
        utm_campaign: "",
        utm_content: "",
        utm_term: "",
        utm_id: "",
    }

};

apiFetch({
    path: '/post-grid/v2/get_plugin_data',
    method: 'POST',
    data: {},
}).then((res) => {

    //console.log(res);

    window.PostGridPluginData = res;
});










import './store'
import './templates'


import './blocks/post-grid'
import './blocks/post-grid-filterable'

import './blocks/post-title'
import './blocks/post-excerpt'
import './blocks/post-featured-image'
import './blocks/image'
import './blocks/post-author'
import './blocks/post-author-fields'
import './blocks/post-categories'
import './blocks/post-tags'
import './blocks/post-taxonomies'
import './blocks/post-date'
import './blocks/post-meta'
import './blocks/read-more'
import './blocks/post-comment-count'



import './blocks/list'


// import './blocks/list-nested'
// import './blocks/list-nested-item'

import './blocks/icon'
import './blocks/text'
import './blocks/star-rate'
import './blocks/breadcrumb'
import './blocks/shortcode'
import './blocks/social-share'
// import './blocks/divider'

import './blocks/terms-list'
import './blocks/archive-title'
import './blocks/archive-description'


import './blocks/layers'
import './blocks/layer'
import './blocks/flex-wrap'
import './blocks/flex-wrap-item'

import './blocks/grid-wrap'
import './blocks/grid-wrap-item'


import './blocks/accordion'

import './blocks/accordion-nested'
import './blocks/accordion-nested-item'
import './blocks/tabs'

import './blocks/tabs-nested'
import './blocks/tabs-nested-item'

// import './blocks/woo-product-excerpt'




// const addBlockEditAttributes = createHigherOrderComponent((BlockEdit) => {
//     return (props) => {
//         const { attributes, setAttributes, clientId } = props;

//         const {
//             blockId,
//         } = attributes;

//         console.log(props);
//         //props.attributes.blockId = 'pg' + clientId.split('-').pop();

//         return <BlockEdit {...props} />;
//     };
// }, 'addBlockEditAttributes');

// addFilter(
//     'editor.BlockEdit',
//     'post-grid/text',
//     addBlockEditAttributes
// );
// addFilter(
//     'editor.BlockEdit',
//     'post-grid/layers',
//     addBlockEditAttributes
// );